import { render, staticRenderFns } from "./JingXiangRechargeView.vue?vue&type=template&id=70823bcb&scoped=true"
import script from "./JingXiangRechargeView.vue?vue&type=script&lang=js"
export * from "./JingXiangRechargeView.vue?vue&type=script&lang=js"
import style0 from "./JingXiangRechargeView.vue?vue&type=style&index=0&id=70823bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70823bcb",
  null
  
)

export default component.exports